import { Modal, InputDS, ButtonDS, Spacer } from "@qivia/ui";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import "../../../../i18n/i18n";

export type FormPassword = {
  password: string;
  newPassword: string;
  confirmedPassword: string;
};

export const UpdatePasswordModal = (props: {
  visible: boolean;
  onClose: () => void;
  onSubmit: (data: FormPassword) => void;
  isNewPasswordMatching: boolean;
  isCurrentPasswordCorrect: boolean;
  passwordStatus: string;
}) => {
  const { t } = useTranslation();
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const { handleSubmit, reset, formState, register } = useForm<FormPassword>();

  useEffect(() => {
    formState.isValid ? setButtonDisabled(false) : setButtonDisabled(true);
  }, [formState]);

  useEffect(() => {
    if (props.visible === false) reset();
  }, [reset, props.visible]);

  return (
    <Modal
      title={t("users.security.modal.title") || ""}
      visible={props.visible}
      onClose={() => {
        props.onClose();
      }}
    >
      <StyledForm
        onSubmit={(event) => void handleSubmit(props.onSubmit)(event)}
      >
        <InputDS
          label={t("users.security.modal.password.label") || ""}
          placeholder={t("users.security.modal.password.placeholder") || ""}
          {...register("password", {
            required: `${t("users.security.modal.error.input")}`,
          })}
          error={
            props.isCurrentPasswordCorrect
              ? formState.errors.password?.message
              : `${t("users.security.modal.password.error")}`
          }
          type="PASSWORD"
        />

        <InputDS
          label={t("users.security.modal.newPassword.label") || ""}
          placeholder={t("users.security.modal.newPassword.placeholder") || ""}
          {...register("newPassword", {
            required: `${t("users.security.modal.error.input")}`,
          })}
          error={
            props.isNewPasswordMatching
              ? formState.errors.newPassword?.message
              : `${t("users.security.modal.newPassword.error")}`
          }
          type="PASSWORD"
        />

        <InputDS
          label={t("users.security.modal.confirmedPassword.label") || ""}
          placeholder={
            t("users.security.modal.confirmedPassword.placeholder") || ""
          }
          {...register("confirmedPassword", {
            required: `${t("users.security.modal.error.input")}`,
          })}
          error={
            props.isNewPasswordMatching
              ? formState.errors.confirmedPassword?.message
              : `${t("users.security.modal.newPassword.error")}`
          }
          type="PASSWORD"
        />
        <StyledButton>
          <ButtonDS
            text={t("users.security.modal.add") || ""}
            disabled={buttonDisabled}
            buttonType={"primary"}
            format={"fill"}
          />
        </StyledButton>
        <Spacer y={1.5} />
      </StyledForm>
    </Modal>
  );
};

const StyledButton = styled.div`
  display: flex;
  border: solid 0.25rem transparent;
  justify-content: flex-end;
`;

const StyledForm = styled.form`
  width: 100%;
`;
